<template>
  <v-card color="grey lighten-3">
    <v-layout wrap align-center class="body-2">
      <v-flex class="pa-2">
        <span class="success--text">Online</span>
        <span class="ml-2">{{ countAgentStatus ? countAgentStatus.online : 0 }}</span>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex class="pa-2">
        <span class="error--text">Offline</span>
        <span class="ml-2">{{ countAgentStatus ? countAgentStatus.offline : 0 }}</span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      countAgentStatus: 'countAgentStatus'
    })
  },
  mounted() {
    if (!this.countAgentStatus) {
      this.$store.dispatch('loadAgentStatusOnlineOffline')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/WorkTime/StatusOverview.vue